/* eslint-disable promise/param-names */
import { AUTH_REQUEST, AUTH_ERROR, AUTH_SUCCESS, AUTH_LOGOUT, AUTH_REFRESH, AUTH_CLEAR } from '../actions/auth';
import { USER_REQUEST } from '../../store/actions/user';
import { tokenCall } from '../../utils/api';

const state = { token: localStorage.getItem('user-token') || '', status: '', hasLoadedOnce: false };

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
};

const actions = {
  [AUTH_REQUEST]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REQUEST);
      tokenCall({data: user})
      .then(resp => {
        localStorage.setItem('user-token', resp.data.access_token);
        commit(AUTH_SUCCESS, resp);
        //dispatch(USER_REQUEST, {authToken: resp.data.access_token});
        resolve(resp);
      })
      .catch(err => {
        commit(AUTH_ERROR, err);
        localStorage.removeItem('user-token');
        reject(err);
      });
    });
  },
  [AUTH_LOGOUT]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_LOGOUT);
      localStorage.removeItem('user-token');
      resolve();
    })
  },
   [AUTH_CLEAR]: ({commit, dispatch}) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_CLEAR);
      localStorage.removeItem('user-token');
      resolve();
    })
  },
  [AUTH_REFRESH]: ({commit, dispatch}, user) => {
    return new Promise((resolve, reject) => {
      commit(AUTH_REFRESH);
      tokenCall({data: user})
      .then(resp => {
        localStorage.setItem('user-token', resp.data.access_token);
        // Here set the header of your ajax library to the token value.
        // example with axios
        // axios.defaults.headers.common['Authorization'] = resp.token
        commit(AUTH_SUCCESS, resp);
        dispatch(AUTH_REFRESH);
        resolve(resp);
      })
      .catch(err => {
        commit(AUTH_ERROR, err);
        localStorage.removeItem('user-token');
        reject(err);
      })
    })
  },
};

const mutations = {
  [AUTH_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [AUTH_SUCCESS]: (state, resp) => {
    state.status = 'success';
    state.token = resp.data.access_token;
    state.hasLoadedOnce = true;
  },
  [AUTH_ERROR]: (state) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
  },
  [AUTH_LOGOUT]: (state) => {
    state.token = '';
  },
  [AUTH_CLEAR]: (state) => {
    state.token = '';
    status: '';
  },

  [AUTH_REFRESH]: (state) => {
    state.status = 'loading';
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
}
